(ns trellis.toggle
  (:require [dnd.util :refer [cls]]
            [material-ui.core :as m]))

(defn toggle-text
  [{:keys [label]}]
  [:span {:class (cls "absolute top-0"
                      "block"
                      "text-center"
                      "w-[1px] h-[1px]"

                      "text-trellis-typography-heading-50-font-size"
                      "font-trellis-typography-heading-50-font-weight"
                      "text-trellis-typography-heading-50-font-family"

                      "trellis-color-text-core-on-fill-default"


                      "border-none"
                      "overflow-hidden"
                      "line-height-[41px]"
                      "text-center"
                      "top-0"
                      "display-block")}
   label])

(defn toggle-handle
  [{:keys [checked
           size]}
   & children]
  (into [:span {:class (cls "absolute top-0"
                            (if checked
                              "left-[calc(100%-26px)]"
                              "left-0")
                            "will-change-[left]"
                            "h-[26px]"
                            "w-[26px]"
                            (if (= size "sm")
                              "p-[5px]"
                              "p-[7px]")
                            "overflow-hidden"

                            "bg-trellis-color-icon-core-on-fill-default"

                            ;; border (tiny bit crazy implementation)
                            (if checked
                              "shadow-[0_0_0_1px_#141414,0_5px_5px_0_rgba(0,0,0,0.08)]"
                              "shadow-[0_0_0_1px_#8A8A8A,0_5px_5px_0_rgba(0,0,0,0.08)]")
                            "rounded-trellis-border-radius-100"

                            ;; animation
                            "transition-all")}]
        children))

(defn switch
  [{:keys [checked]}
   & children]
  (into [:span {:data-comp-name "switch"
                :class (cls "relative"
                            "inline-block"
                            "align-middle"

                            ;; size (xs)
                            "h-[26px]"
                            "w-[52px]"
                            "min-w-0"

                            ;; color
                            (if checked
                              "bg-trellis-color-icon-interactive-default"
                              "bg-trellis-color-fill-field-disabled")

                            ;; border (tiny bit crazy implementation)
                            "border-solid"
                            (if checked
                              "shadow-[inset_0_0_0_var(--trellis-border-width-100,1px)_initial]"
                              "shadow-[inset_0_0_0_var(--trellis-border-width-100,1px)_var(--trellis-color-border-core-default,#8C8787)]")

                            ;; radius
                            "rounded-trellis-border-radius-100")}]
        children))

(defn screenreader-only
  [props & children]
  (into [:span {:class (cls "absolute top-0"
                            "w-px hpx"
                            "m-trellis-space-25"
                            "p-0"
                            "border-none"
                            "overflow-hidden")}]
        children))

(defn left-label
  [{:keys [id]} & children]
  [:label {:htmlFor id
           :class (cls "inline-block align-middle"
                       "cursor-default"

                       ;; space
                       "pt-trellis-space-200"
                       "pb-trellis-space-100"
                       "pr-trellis-space-300")}
   (into [:span {:class (cls "text-trellis-typography-heading-50-font-size"
                             "font-trellis-typography-heading-50-font-weight"
                             "text-trellis-typography-heading-50-font-family"
                             "text-trellis-color-text-core-default"
                             "tracking-trellis-typography-heading-50-letter-spacing"
                             "leading-trellis-typography-heading-50-line-height"
                             "m-0 p-0")}]
         children)])

;; breaking from HS impl to contain the label in here
(defn toggle
  [{:keys [id
           label
           checked
           onChange
           size
           ;; OCH custom
           fullWidth]}]
  {:pre [(contains? #{"xs"} size)
         (string? label)
         (string? id)
         (boolean? checked)]}
  [:div {:class (cls "m-0 p-0"
                     "whitespace-nowrap"
                     (when fullWidth
                       "w-full flex flex-row items-center justify-between"))}
   ;; left label
   [left-label {:id id} label]

   ;; outer
   [:label {:class (cls "relative"
                        "inline-block"
                        "align-middle"
                        "select-none cursor-pointer")}
    ;; screenreader only
    [screenreader-only {}
     [:input {:type "checkbox"
              :id id
              :value checked
              :onChange onChange}]]

    ;; text
    [switch {:checked checked}
     [toggle-text {:label "ON"}]
     [toggle-text {:label "OFF"}]
     [toggle-handle {:size "sm"
                     :checked checked}
      (when checked
        [:div {:class (cls "flex items-center justify-center")}
         [:> m/CheckIcon {:style {:fontSize "15px"}}]])]]]])
